// extracted by mini-css-extract-plugin
export default {"toggleButton":"ThemeToggle_toggleButton__USG7u","icon":"ThemeToggle_icon__RGMQ2"};